import { SituacaoEnum } from '@/utils/enumerados';
import elementoVisivel from '../dom';

const SELECTOR_DEFINIR = '[data-tour="prazos-recursais-definir"]';
const SELECTOR_AJUSTAR = '[data-tour="prazos-recursais-ajustar"]';
const SELECTOR_SITUACAO = '[data-tour="situacao"]';
const SELECTOR_ENCERRAR = '[data-tour="prazos-recursais-encerrar"]';
const SELECTOR_ABA = '[data-tour="prazos-recursais-aba-recursos"]';

function botaoPrazosSelector() {
  if (elementoVisivel(SELECTOR_DEFINIR)) return SELECTOR_DEFINIR;
  if (elementoVisivel(SELECTOR_AJUSTAR)) return SELECTOR_AJUSTAR;
  return null;
}

export default {
  id: 'prazos-recursais',
  kind: 'tour',
  version: 1,
  label: 'Fase recursal e prazos',
  contexts: ['auction.situation'],
  situation: SituacaoEnum.INTERPOSICAO_DE_RECURSOS,
  priority: 10,
  help: true,
  canStart(ctx = {}) {
    if (!ctx.logged) return false;
    if (Number(ctx.situation) !== SituacaoEnum.INTERPOSICAO_DE_RECURSOS) return false;
    // Pregoeiro vê botões de prazos; licitante/visitante vêem situação e/ou aba Recursos.
    return Boolean(
      botaoPrazosSelector() || elementoVisivel(SELECTOR_SITUACAO) || elementoVisivel(SELECTOR_ABA),
    );
  },
  steps() {
    const steps = [
      {
        element: SELECTOR_SITUACAO,
        popover: {
          title: 'Fase recursal',
          description:
            'O pregão está na interposição de recursos. Aqui você acompanha a situação e as ações desta fase.',
          side: 'bottom',
          align: 'center',
        },
      },
    ];

    const botaoPrazos = botaoPrazosSelector();
    if (botaoPrazos) {
      const isDefinir = botaoPrazos === SELECTOR_DEFINIR;
      steps.push({
        element: botaoPrazos,
        popover: {
          title: isDefinir ? 'Definir Prazos' : 'Ajustar Prazos',
          description: isDefinir
            ? 'Use este botão para definir os prazos de recursos, contrarrazões e consideração/julgamento.'
            : 'Use este botão para ajustar os prazos recursais já definidos, quando necessário.',
          side: 'bottom',
          align: 'center',
        },
      });
    }

    if (elementoVisivel(SELECTOR_ENCERRAR)) {
      steps.push({
        element: SELECTOR_ENCERRAR,
        popover: {
          title: 'Encerrar prazo',
          description:
            'No menu de mais ações (⋮) você pode antecipar o encerramento do prazo da janela recursal vigente.',
          side: 'left',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(SELECTOR_ABA)) {
      steps.push({
        element: SELECTOR_ABA,
        popover: {
          title: 'Aba Recursos',
          description:
            'Nesta aba os licitantes enviam recursos e contrarrazões; o pregoeiro considera e a autoridade julga.',
          side: 'bottom',
          align: 'start',
        },
      });
    }

    return steps;
  },
};
